import type { FaireProductEntity } from "../../entity_types/product";

export const p_6394c9ymyt: FaireProductEntity = {
  token: "p_6394c9ymyt",
  type: "product",
  name: "Voyage Shirt Dress - Black Stripes",
  brandToken: "b_2zdmtoaf",
  brandName: "The Handloom",
  imageUrl:
    "https://cdn.faire.com/fastly/af0ef9632af5f87421e7338da5ec4dd7469aa981458be109f64979c509b50aba.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0558f267e81e0e714e975293276e5bcb2a11a3c0df86000aebac10aa9e2765cd.jpeg",
    "https://cdn.faire.com/fastly/b9327a151a333b1c5641344e6f8bf337ce83ff8d55995d986969f91ee4798b6d.jpeg",
    "https://cdn.faire.com/fastly/cdff610d86ceaea2857aeed2fd6045f4b527f6df64e56b45fd8539caf66cfa42.jpeg",
    "https://cdn.faire.com/fastly/b825972eb247decbbb53731cd5e50c76210ceb09c871bab55116ba0e0ec9c5f8.jpeg",
    "https://cdn.faire.com/fastly/ec0b23c06a52d49060baaef0109021bfb2387513c19c75bd80045f237e14060d.jpeg",
    "https://cdn.faire.com/fastly/00ba30056ce42493de2938649175356dbdab96cfad2bad1a2dbfb320923d02f6.jpeg",
    "https://cdn.faire.com/fastly/3ce2b593a4365b9aae5e3f4fac4c2b064c28601ebba6d8af9818f45a00f3210b.jpeg",
    "https://cdn.faire.com/fastly/4efda3c04551a0796bdd41041658629b1bf859c52462e120a15857d4632b6727.jpeg",
  ],
  priceDollars: 79,
  description:
    "Featuring a button-down front and a relaxed fit, this versatile shirt dress offers effortless layering. Crafted from 100% Turkish cotton with soft, hand-loomed striped fabric, it can be worn open-front over swimwear or buttoned up as a chic beach cover-up. With a classic collar and rollable sleeves, it’s an essential addition to your summer wardrobe, perfect for beachside lounging or strolling through vacation days in style.\n\n- Crafted from 100% Turkish cotton\n- Side slits\n\n* The model wearing the product in the photos is 5'11\" (180 cm) tall, and wears size S/M.\n",
  tags: [],
  msrpDollars: 158,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:56.829Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
